import {useTranslation} from 'react-i18next'
import styles from './Materials.module.scss'
import { ReactComponent as DocSvg } from 'assets/images/doc.svg'
// import { ReactComponent as DownSvg } from 'assets/images/down.svg'
import useSWR from 'swr'
import { useEffect, useState } from 'react'
import axios from 'axios'

const fetcher = async url => {
    const res = await axios(url)
    if (Array.isArray(res.data)) {
        return [...res.data]
    }
    return res.data
}

const selectByLang = (lang, data)=> {
    if (!data) return []
    const actual = data?.filter(item => item.active !== 0)
    return actual?.map(item => ({
        id: item.id,
        path: lang === 'ru' ? item.path_ru : item.path_en,
        name: lang === 'ru' ? item.name_ru : item.name_en,
        extension: item.extension
    }))
}


export const Materials = ()=> {
    const [currentData, setCurrentData] = useState([])
    const { data } = useSWR(process.env.REACT_APP_BACKEND+'/files', fetcher)
    const { t, i18n } = useTranslation()
    useEffect(()=> {
        setCurrentData(selectByLang(i18n.language, data))
    }, [i18n, i18n.language, data])

    const onOpen =(path)=> ()=> {
        window.open(path, '_bank')
    }

    return (
        <section className={styles.section} id="material">
            <div className="container">
                <div className={styles.block}>
                    <h2 className={styles.title}>
                        {t('materials.title')}
                    </h2>

                    <div className={styles.wrap}>
                        {currentData.map(item => (
                            <div className={styles.box} key={item.id}>
                                <div className={styles.head}>
                                    <DocSvg />
                                    <div className={styles.mid_title}>
                                        {item.name||
                                            t('materials.mid_title_1')
                                        }
                                    </div>
                                </div>
                                <button className={['btn', styles.btn].join(' ')} onClick={onOpen(item.path)}>
                                    {t('materials.btn_show')}
                                </button>
                            </div>
                        ))}
                    </div>

                    {/* <button className={['btn', styles.down].join(' ')}>
                        <DownSvg />
                        {t('materials.btn')}
                    </button> */}
                </div>
            </div>
        </section>
    )
}
